<template lang="pug">
  #app
    terms-banner
    alert-pop
    transition(name="up", mode="out-in")
      component(:is="layout")
</template>

<script>
import AlertPop from '@/components/widgets/AlertPop';
import TermsBanner from '@/components/widgets/TermsBanner';
import { mapActions, mapGetters } from 'vuex';
import LayoutBasic from '@/components/layout/LayoutBasic';
import LayoutHero from '@/components/layout/LayoutHero';
import LayoutClean from '@/components/layout/LayoutClean';
import LayoutApp from '@/components/layout/LayoutApp';

export default {
  name: 'App',
  components: {
    TermsBanner,
    AlertPop,
    'layout-basic': LayoutBasic,
    'layout-clean': LayoutClean,
    'layout-app': LayoutApp,
    'layout-hero': LayoutHero,
  },
  computed: {
    ...mapGetters('layout', ['layout']),
  },
  watch: {
    $route(to) {
      console.log({ to });
      document.title = to.meta.title ? `${to.meta.title} | Wall Collective` : 'Wall Collective';
    },
  },
  methods: {
    ...mapActions('resource', ['updateState']),
  },
  created() {
    this.updateState();
  },
};
</script>

<style lang="scss">
  body,
  html {
    position: relative;
    width: 100%;
    height: 100%;
  }
  #app{
    height: 100%;
    background-color: black;
  }

  .up-enter-active, .page-leave-active {
    transition: transform 0.4s;
  }
  .up-enter {
    transform: translateY(100%);
  }

  // .page-enter-to {
  //   transform: translateX(0%);
  // }

  .up-leave-to {
    transform: translateY(-100%);
  }

</style>



// WEBPACK FOOTER //
// src/App.vue